import {Checkbox, Col, Empty, Input, Modal, Row} from "antd";
import {useEffect, useState} from "react";
import i18next from "i18next";
import * as RoleBackend from "../../services/RoleBackend";
import "../../assets/styles/user/UserTransfer.less";

export const UserRoleEditModal = (props) => {
  const {visible, dismiss, owner, userRoles, onChangeRole} = props;
  const [searchText, setSearchText] = useState("");
  const [roles, setRoles] = useState([]);

  useEffect(() => {
  });

  useEffect(() => {
    if (visible) {
      setSearchText("");
      fetchUserRole();
    }
  }, [visible]);

  const fetchUserRole = (params = {}) => {
    RoleBackend.getRoles(owner)
      .then(res => {
        if (res.msg === undefined) {
          setRoles(res);
        }
      });
  };

  const getRoles = (searchKey) => {
    if (searchKey === "") {
      return roles;
    }
    const arr = roles.filter(item => item.displayName.includes(searchKey));
    return arr;
  };

  const getStaticRoles = (arr) => {
    if (!arr) {
      return [];
    }
    return arr.filter(item => item.isStaticRole);
  };

  const onSearchKey = (value) => {
  };

  const	onRowChange = (e) => {
    const found = roles.find(item => item.uid === e.target.value);
    if (found) {
      let selectedRoles;
      if (e.target.checked) {
        selectedRoles = [...userRoles, found];
      } else {
        selectedRoles = userRoles.filter(item => item.uid !== e.target.value);
      }
      onChangeRole(selectedRoles);
    }
  };

  return <Row>
    <Modal
      className="modal-import-user"
      maskClosable={true}
      destroyOnClose={true}
      closable={false}
      title={i18next.t("")}
      visible={visible}
      footer={null}
      onCancel={() => {dismiss();}}
      width={400}
    >
      <Row style={{marginTop: "20px", marginBottom: "0px"}} justify="center">
        <Col span={24} style={{padding: "0 12px"}}>
          <Input.Search
            style={{
              marginTop: 20,
            }}
            allowClear={true}
            placeholder={i18next.t("user:Please input static role name")}
            onChange={(e) => {setSearchText(e.target.value);}}
            value={searchText}
            onSearch={(value) => {
              onSearchKey(value);
            }}
          />
        </Col>
      </Row>
      {
        <Checkbox.Group
          style={{
            width: "100%",
          }}
          value={getStaticRoles(userRoles).map(item => item.uid)}
        >
          <div style={{display: "flex", flexDirection: "column", height: 300, paddingBottom: 10, overflow: "auto"}}>
            {
              getStaticRoles(getRoles(searchText)).length > 0 ?
                getStaticRoles(getRoles(searchText)).map(role =>
                  <div key={role.uid} style={{padding: "6px 12px 2px 20px", height: 30}}>
                    <Checkbox onChange={onRowChange} value={role.uid}>{role.displayName}</Checkbox>
                  </div>
                )
                :
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} style={{marginTop: 50}} />
            }
          </div>
        </Checkbox.Group>
      }
    </Modal>
  </Row>;
};

export default UserRoleEditModal;
